import { SET_GUEST_BULK_PICKUP_INCLUDED_CATEGORIES } from "constants-lib/actionTypes"

export const fulfilledAC = (data) => ({
  type: SET_GUEST_BULK_PICKUP_INCLUDED_CATEGORIES,
  payload: { data },
})

export const setGuestBulkPickupIncludedCategories = (data) => (dispatch) => {
  dispatch(fulfilledAC(data))
}
